export const messagesTrackers = {
    pt: {
        message:{
            accessToken: "Token de acesso",
            create: "Criar Rastreador",
            clearData: "Limpar dados",
            metaPixelHint: "Para começar a rastrear os eventos dos seus usuários usando o Meta Pixel, bastar inserir e salvar o seu PixelId.",
            name: "Nome",
            pixelCode: "Código do pixel",
            pixelId: "Pixel Id",
            selectTrackerType: "Selecione o tipo do rastreador",
            setAsDefaultTracker: "Definir como Rastreador padrão",
            trackers: "Rastreadores"
        }
    },
    es: {
        message:{
            accessToken: "Token de acesso",
            create: "Crear Rastreador",
            clearData: "Limpar dados",
            metaPixelHint: "Para começar a rastrear os eventos dos seus usuários usando o Meta Pixel, bastar inserir e salvar o seu PixelId.",
            name: "Nombre",
            pixelCode: "Código do pixel",
            pixelId: "Pixel Id",
            selectTrackerType: "Seleccione el tipo de rastreador",
            setAsDefaultTracker: "Establecer como rastreador predeterminado",
            trackers: "Rastreadores"
        }
    },
    en: {
        message:{
            accessToken: "Access token",
            create: "Create Tracker",
            clearData: "Clear data",
            metaPixelHint: "To start tracking your users' events using Meta Pixel, just enter and save your PixelId.",
            name: "Name",
            pixelCode: "Pixel code",
            pixelId: "Pixel Id",
            selectTrackerType: "Select tracker type",
            setAsDefaultTracker: "Set as default tracker",
            trackers: "Trackers"
        }
    }
}
